import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display:flex;
    flex-direction:column;

`

export function PageButtons(props){
    return <Container>
        {props.children}
    </Container>
}